<template>
  <!--
    A native select styled as the secondary button next to it. It stays a
    select so keyboard navigation and the system specs that pick a language
    by its `name` keep working.
  -->
  <span class="tw-relative tw-inline-flex tw-items-center tw-h-8">
    <!-- tw-w-auto and tw-m-0 lift the legacy 220px width and 10px bottom margin every select inherits. -->
    <select
      v-model="selected"
      name="language"
      class="
        sf-button sf-button--secondary sf-button--lg
        tw-appearance-none tw-w-auto tw-m-0
        !tw-pr-7
        tw-cursor-pointer
      "
      data-testid="graph-language-select"
    >
      <option
        v-for="language in languages"
        :key="language.locale"
        :value="language.locale"
      >
        {{ language.language }}
      </option>
    </select>
    <i
      class="
        fa fa-caret-down
        tw-pointer-events-none
        tw-absolute
        tw-right-2
        tw-top-1/2
        tw--translate-y-1/2
        tw-text-sf-slate
      "
      aria-hidden="true"
    />
  </span>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'

defineOptions({
  name: 'GraphLanguageSelect',
})

interface Language {
  locale: string
  language: string
}

const props =
  defineProps<{
    languages: Language[]
    modelValue: string
  }>()

const emit =
  defineEmits<{
    'update:modelValue': [value: string]
  }>()

const selected = useVModel(props, 'modelValue', emit, { passive: true })
</script>
